module.exports = __webpack_public_path__ + "img/500-error.5c6b0f12.svg";